import React from 'react';
import EnhancedTable from '../components/EnhancedTable';

/**
 * Represents the StartPage component displaying introductory content.
 *
 * @component
 * @returns {JSX.Element} The rendered StartPage component.
 */
function StartPage() {
  return (
    <div>
     <EnhancedTable></EnhancedTable>
    </div>
  );
}

export default StartPage;
